import React from 'react';
import DetailsBox from '../common/DetailsBox/DetailsBox';
import StatsWidget from '../common/StatsWidget/StatsWidget';
import ReactCountryFlag from 'react-country-flag';
import './CommonView.scss';
import { SvgIcon } from '../common';

const DvpnnodesDetails = () => {
    return (
        <DetailsBox
            subtitle="Soft Orange Boar"
            subtitlelink="nodelist"
            >
            <div className="nodes-head">
                <div className="stars">
                    <SvgIcon name="star" viewbox="0 0 37.617 36.004" />
                    <SvgIcon name="star" viewbox="0 0 37.617 36.004" />
                    <SvgIcon name="star" viewbox="0 0 37.617 36.004" />
                    <SvgIcon name="star" viewbox="0 0 37.617 36.004" />
                    <SvgIcon name="star" viewbox="0 0 37.617 36.004" />
                </div>
                <div className="d-flex align-items-center mb-2">
                    <ReactCountryFlag svg countryCode="us"
                        style={{
                            width: '1.5em',
                            height: '1.5em',
                        }}
                    />
                    <div className="validator-name ml-2">Exotic Topaz Tapir</div>
                </div>
                <div>IP: 1.254.254.254</div>
            </div>
            <div className="validators-content">
                <StatsWidget
                    title="Version"
                    statsnumbers="0.28"
                />
                <StatsWidget
                    title="Peers"
                    statsnumbers="0"
                />
                <StatsWidget
                    title="Speed"
                    statsnumbers="50 MB/S"
                />
                <StatsWidget
                    title="Speed"
                    statsnumbers="70 MB/S"
                />
                <StatsWidget
                    title="Encyption"
                    statsnumbers="AEC 256"
                    
                />
                <StatsWidget
                    title="Latancy"
                    statsnumbers="13.114"
                />
                <StatsWidget
                    title="Address"
                    statsnumbers="sentvaloper12134124asda..."
                    className="full-width-grid"
                />
            </div>
        </DetailsBox>
    )
}

export default DvpnnodesDetails